/** A candidate's comment in a table: one muted line, the full text on hover; a dash when empty. */
export const CommentCell = ({ text }: { text?: string }) =>
  text ? (
    <span className="block max-w-64 truncate text-muted-foreground" title={text}>
      {text}
    </span>
  ) : (
    <span className="text-muted-foreground">—</span>
  );

/** The Source column's per-column filter: one option per known source. */
export const sourceColumnFilter = (sources: readonly string[]) => ({
  type: 'options' as const,
  options: sources.map((source) => ({ value: source, label: source })),
});

/**
 * The names in a JSON list of people (`InternalReferralJson`, `InterviewPanelJson`): entries are
 * `{ name }` / `{ DisplayName }` objects or plain strings; anything unreadable gives an empty list.
 */
export const namesInJson = (json?: string): string[] => {
  if (!json) return [];
  try {
    const parsed: unknown = JSON.parse(json);
    if (!Array.isArray(parsed)) return [];
    return parsed
      .map((entry) => {
        if (typeof entry === 'string') return entry;
        if (entry && typeof entry === 'object') {
          const record = entry as { name?: unknown; DisplayName?: unknown };
          if (typeof record.name === 'string') return record.name;
          if (typeof record.DisplayName === 'string') return record.DisplayName;
        }
        return '';
      })
      .filter(Boolean);
  } catch {
    return [];
  }
};
